exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "table.inspectionReviewReport{background:#fff}table.inspectionReviewReport,table.subTable1,table.subTable2{width:100%;border-collapse:collapse}table.inspectionReviewReport td{font-size:12px;vertical-align:top;padding:4px;text-align:left}table.inspectionReviewReport tr th,table.subTable1 tr th,table.subTable2 tr th{font-weight:400;font-size:12px}.reportFontBold{font-weight:700}table.subTable1 td,table.subTable1 tr th,table.subTable2 td,table.subTable2 tr th{border:1px solid #ccc;text-align:center}.subTable1 td:nth-child(2),.textLeft,.textLeft td:nth-child(2),.textLeft td:nth-child(3),.textLeft td:nth-child(4){text-align:left!important}.center{width:50%}.center,.center2{display:block;margin-left:auto;margin-right:auto}.center2{width:10%}.pageBeak{page-break-after:always}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./assets/css/printReport.css
// module id = 1892
// module chunks = 3